import { registerQuery } from 'data-fetching-client';
import { fetchEmbedFeaturePermissions, fetchFeaturePermissions, fetchFeaturePermissionsByFlowId } from 'automation-ui-permissions/feature-permissions/api/featurePermissionsApi';
export const FEATURE_PERMISSIONS_FIELD_NAME = 'featurePermissions';
export const GET_FEATURE_PERMISSIONS = registerQuery({
  fieldName: FEATURE_PERMISSIONS_FIELD_NAME,
  args: [],
  fetcher: fetchFeaturePermissions
});
export const FEATURE_PERMISSIONS_BY_FLOW_ID_FIELD_NAME = 'featurePermissionsByFlowId';
export const GET_FEATURE_PERMISSIONS_BY_FLOW_ID = registerQuery({
  fieldName: FEATURE_PERMISSIONS_BY_FLOW_ID_FIELD_NAME,
  args: ['flowId'],
  fetcher: fetchFeaturePermissionsByFlowId
});
export const EMBED_FEATURE_PERMISSIONS_FIELD_NAME = 'embedFeaturePermissions';
export const GET_EMBED_FEATURE_PERMISSIONS = registerQuery({
  fieldName: EMBED_FEATURE_PERMISSIONS_FIELD_NAME,
  args: [],
  fetcher: fetchEmbedFeaturePermissions
});